import * as React from "react";
import {Grid, Paper, TextField, Typography} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import RenewalMonthsSelector from "./RenewalMonthsSelector";

function getFeeTotal(fee: any) {
    let total = 0;
    if (fee.transaction) {
        total += fee.transaction;
    }
    if (fee.data) {
        total += Number(fee.data);
    }
    return Math.round(total * 10000) / 10000;
}

class AssetDataFees extends React.Component<any, any> {
    
    public render() {
        const {
            agreement: {
                states: [state],
                data: { entity },
            },
            fees,
            classes
        } = this.props;

        if (!Object.keys(fees).length) {
            return null;
        }

        const tableHeaders =
            <>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Fee description
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Transaction (NxtPort)
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Data ({entity.name})
                    </Typography>
                </Grid>
                <Grid item xs={3}>
                    <Typography variant="caption" className={classes.feeHeading}>
                        Total
                    </Typography>
                </Grid>
            </>;

        const tableRows = <>
            {Object.values(fees).map((fee: any) => (
                <React.Fragment key={fee.id}>
                    <Grid item xs={3}>
                        <Typography>{fee.description}</Typography>
                    </Grid>
                    <Grid item xs={3}>
                        {fee.transaction !== undefined ? (
                            <TextField
                                value={fee.transaction}
                                type="number"
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                }}
                                disabled
                                fullWidth
                            />
                        ) : null}
                    </Grid>
                    <Grid item xs={3}>
                        {fee.data !== undefined ? (
                            <TextField
                                id={fee.id}
                                value={fee.data}
                                type="number"
                                onChange={this.props.onFeeUpdate}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">€</InputAdornment>,
                                }}
                                disabled={!this.props.configuration[state.id].sendFees}
                                fullWidth
                            />
                        ) : null}
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            type="number"
                            value={getFeeTotal(fee)}
                            InputProps={{
                                startAdornment: <InputAdornment position="start">€</InputAdornment>,
                            }}
                            disabled
                            fullWidth
                        />
                    </Grid>
                </React.Fragment>
            ))}
        </>;

        return (
            <React.Fragment>
                <Typography variant="title" className={classes.title}>
                    Fees
                </Typography>
                <Paper className={classes.paper}>
                    <Grid container spacing={24}>
                        {tableHeaders}
                        {tableRows}
                        <Grid item xs={3}>
                            <RenewalMonthsSelector
                                onChangeDurationMonths={this.props.onChangeDurationMonths}
                                agreement={this.props.agreement}
                                durationMonths={this.props.durationMonths}
                                configuration={this.props.configuration}
                            />
                        </Grid>
                    </Grid>
                </Paper>
            </React.Fragment>
        );
    }
}

export default AssetDataFees;


// WEBPACK FOOTER //
// ./src/modules/shared/dataSharing/AssetDataFees.tsx